module.exports = __webpack_public_path__ + "images/help/video-docs-small@2x-8f6982218d58cf1f7307d028b35691fc.png";